import GoogleReCaptcha from "./GoogleReCaptcha";

export default GoogleReCaptcha;
